import { Checkbox } from 'antd';

export const columns = ({ checkedKeys, onCheck, onPermissionChange }: any) => {
  const handleCheckChange = (node: { key: string }, checked: boolean) => {
    onCheck(node.key, checked);
  };

  const handlePermissionChange = (
    node: { key: string },
    permissionType: string,
    checked: boolean,
  ) => {
    onPermissionChange(node.key, permissionType, checked);
  };

  const handleChildrenCheckChange = (node: any, checked: boolean) => {
    if (node.children.length > 0) {
      node.children.map((child: any) => {
        onCheck(child.key, checked);
        handlePermissionChange(child, 'full', checked);
        handleChildrenCheckChange(child, checked);
      });
    } else {
      return;
    }
  };

  const isNodeIndeterminate = (node: any, allCheckedKeys: string[]) => {
    if (!node.children || node.children.length === 0) return false;
    const childKeys = node.children.map((child: { key: string }) => child.key);
    const checkedChildKeys = childKeys.filter((key: string) =>
      allCheckedKeys.includes(key),
    );

    return (
      checkedChildKeys.length > 0 && checkedChildKeys.length < childKeys.length
    );
  };
  return [
    {
      dataIndex: 'title',
      key: 'title',
      render: (_: any, node: any) => (
        <div className="tw-flex tw-items-center">
          <Checkbox
            indeterminate={isNodeIndeterminate(node, checkedKeys)}
            checked={checkedKeys.includes(node.key) || node.checked}
            onChange={(e: any) => {
              handleCheckChange(node, e.target.checked);
              handlePermissionChange(node, 'full', e.target.checked);
              handleChildrenCheckChange(node, e.target.checked);
            }}
            style={{ marginRight: '12px', marginLeft: '8px' }}
          />
          <span
            style={{
              minWidth: '150px',
            }}
          >
            {node.title}
          </span>
        </div>
      ),
    },
    {
      dataIndex: 'create',
      key: 'create',
      render: (_: any, node: { key: string; create: boolean }) => (
        <div>
          <Checkbox
            checked={node.create}
            onChange={(e) =>
              handlePermissionChange(node, 'create', e.target.checked)
            }
            style={{ marginRight: '12px', marginLeft: '8px' }}
          />
          Create
        </div>
      ),
    },
    {
      dataIndex: 'view',
      key: 'view',
      render: (_: any, node: { key: string; view: boolean }) => (
        <div>
          <Checkbox
            checked={node.view}
            onChange={(e) =>
              handlePermissionChange(node, 'view', e.target.checked)
            }
            style={{ marginRight: '12px', marginLeft: '8px' }}
          />
          View
        </div>
      ),
    },
    {
      dataIndex: 'edit',
      key: 'edit',
      render: (_: any, node: { key: string; edit: boolean }) => (
        <div>
          <Checkbox
            checked={node.edit}
            onChange={(e) =>
              handlePermissionChange(node, 'edit', e.target.checked)
            }
            style={{ marginRight: '12px', marginLeft: '8px' }}
          />
          Edit
        </div>
      ),
    },
    {
      dataIndex: 'delete',
      key: 'delete',
      render: (_: any, node: any) => (
        <div>
          <Checkbox
            checked={node.delete}
            onChange={(e) =>
              handlePermissionChange(node, 'delete', e.target.checked)
            }
            style={{ marginRight: '12px', marginLeft: '8px' }}
          />
          Delete
        </div>
      ),
    },
  ];
};
